module.exports = __webpack_public_path__ + "5002fae16193d8acf391d8c4c3708c8e.svg";